import { router } from '@inertiajs/react'
import { useRef, useState } from 'react'

export default function useAdminAction() {
  const pending = useRef(false)
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState<string | null>(null)

  function run(method: 'patch' | 'post', url: string, data: Record<string, string> = {}, onSuccess?: () => void) {
    if (pending.current) return
    pending.current = true
    setProcessing(true)
    setError(null)
    router[method](url, data, {
      preserveScroll: true,
      onSuccess,
      onError: errors => setError(Object.values(errors).join(' ') || 'The change could not be saved. Try again.'),
      onFinish: () => { pending.current = false; setProcessing(false) },
    })
  }

  return { run, processing, error }
}
